import type { Translatable } from "app/pages/sales-intelligence/types";
import SignalSource from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalSource";

type ModalTranslatables = {
    title: Readonly<Translatable>;
    description: Readonly<Translatable>;
};

export const MODAL_CONTENT_BY_SOURCE: Record<SignalSource, ModalTranslatables> = {
    [SignalSource.Platform]: {
        title: { key: "si.signals.management.title" },
        description: { key: "si.signals.management.description" },
    },
    [SignalSource.Api]: {
        title: { key: "si.signals.management.api.title" },
        description: { key: "si.signals.management.api.description" },
    },
    [SignalSource.Account]: {
        title: { key: "si.signals.management.account.title" },
        description: { key: "si.signals.management.account.description" },
    },
    [SignalSource.RestApi]: {
        title: { key: "si.signals.management.restApi.title" },
        description: { key: "si.signals.management.restApi.description" },
    },
};
